import type {OrderFormState} from '@yandex-delivery/form/ui/OrderForm/types'

import type {VerticalBduiParams} from 'src/shared/types'

/**
 * Мержит предыдущее и новое состояния при изменении данных
 * @param storeState состояние формы из стейта
 * @param formState состояние формы из виджета
 * @param settings значения по умолчанию для вертикали
 */
export function mergeStates(
  storeState: OrderFormState,
  formState: OrderFormState,
  settings?: VerticalBduiParams['defaultValues'],
): OrderFormState {
  const formStateDefaults = settings || {}

  /** подмешиваем дефолты, если вертикаль сменилась */
  const preparedFormState =
    storeState.vertical_name === formState.vertical_name
      ? formState
      : {
          ...formState,
          ...formStateDefaults,
        }

  return {
    ...storeState,
    ...preparedFormState,
  }
}
